module.exports = __webpack_public_path__ + "img/logo.9e8554df.png";